import React from "react";
import { TextField, Typography, Flex } from "../../../components";

interface LocationFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const LocationField: React.FC<LocationFieldProps> = ({ value, onChange }) => {
  return (
    <Flex direction="column" gap="xs">
      <Typography variant="caption" colorScheme="muted" as="span">Location</Typography>
      <TextField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Enter your city, country"
        fullWidth
      />
    </Flex>
  );
};